import { auth } from '../firebase';

/**
 * `Authorization: Bearer <Firebase ID token>` for fetch() calls to our HTTP
 * Cloud Functions, which verify the caller from it. Empty when signed out.
 */
export const idTokenHeader = async () => {
  const idToken = await auth.currentUser?.getIdToken();
  return idToken ? { Authorization: `Bearer ${idToken}` } : {};
};
